import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useMasterTablePermission } from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const MasterTableResourceGuard: FC<
  PropsWithChildren<ResourceGuardProps>
> = ({ onlyEdit, showDenied, children }) => {
  const permission = useMasterTablePermission(onlyEdit);

  if (permission.isPending) {
    return <Loading />;
  }

  return permission.data ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
